import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminCoopPartnersCoopPartnerRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ coop_partner_id }) {
    const { content } = await this.store.request(
      findRecord('coop-partner', coop_partner_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
